// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    function scrollAnimation() {
        // If funcion is an arrow function then the this will be ignored by the function ".call".
        const visible = function(partial) {
            const element = this;
            const viewTop = window.pageYOffset || document.documentElement.scrollTop;
            const viewBottom = viewTop + window.innerHeight;
            const _top = element.offsetTop + 200;
            const _bottom = _top + element.offsetHeight;
            const compareTop = partial === true ? _bottom : _top;
            const compareBottom = partial === true ? _top : _bottom;

            return compareBottom <= viewBottom && compareTop >= viewTop;
        };

        const animatedComponent = document.querySelectorAll('.animate-in');

        // Already visible modules
        animatedComponent.forEach((el) => {
            if (visible.call(el, true)) {
                el.classList.add('already-visible');
            }
        });

        window.addEventListener('scroll', () => {
            animatedComponent.forEach((el) => {
                if (visible.call(el, true)) {
                    el.classList.add('is-animated');
                }
            });
        }, {
            capture: true,
            passive: true
        });
    }

    scrollAnimation();
});